import React, { useState, useRef } from 'react';
import Card from "../components/Card";
import AjaxDynamicDataTable from '@langleyfoxall/react-dynamic-data-table/dist/AjaxDynamicDataTable';
import LoadingIndicator from "../components/datatable/LoadingIndicator";
import EmptyTable from "../components/datatable/EmptyTable";
import {toast} from "react-toastify";
import {DELIVERY_PAGES} from "../pages/JobOrderDeliveryPage";
import ArchiveDeliveryModal from "../modals/ArchiveDeliveryModal";
import PdfDownloadButton from "../components/PdfDownloadButton";

const JobOrderDeliveryDataTable = (props) => {
    const {
        jobId,
        orderId,
        parentId,
        onChangePage    = (CREATE, delivery) => {}
    } = props;

    const dataTableRef = useRef(null);

    const [archiveDeliveryModal, setArchiveDeliveryModal] = useState(null);

    const renderRowButton = (delivery) => {
        return (
            <td>
                <div className={"d-flex justify-content-end align-content-center align-items-center"}>
                    {!!delivery.can && (delivery.can.view === true || can('create', 'delivery') || delivery.can.update === true || delivery.can.delete === true) && (
                        <div className="dropdown">
                            <button
                                className="dropdown-toggle cursor-pointer text-eh-off-black h3"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                            >
                                <i className="far fa-ellipsis-h"/>
                            </button>
                            <div
                                className="dropdown-menu dropdown-menu-right p-0"
                                aria-labelledby="navbarDropdown"
                            >
                                {!!delivery.can.view === true && (
                                    <PdfDownloadButton
                                        label="Download PDF Note"
                                        href={route('job.order.delivery.export', {
                                            job:        jobId,
                                            order:      delivery.order_id,
                                            delivery:   delivery.id
                                        }).toString()}
                                    />
                                )}
                                {!!delivery.can.update === true && (
                                    <button className={"dropdown-item cursor-pointer"}
                                            onClick={() => onChangePage(DELIVERY_PAGES.EDIT, delivery)}
                                    >
                                        <span>Edit Delivery</span>
                                    </button>
                                )}
                                {!!delivery.can.delete === true && (
                                    <button className={"dropdown-item cursor-pointer"}
                                            onClick={() => setArchiveDeliveryModal(delivery)}
                                    >
                                        <span>Delete Delivery</span>
                                    </button>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </td>
        )
    }

    return (
        <React.Fragment>
            <Card
                title={"Deliveries"}
                classes={"mh-100 border-0"}
                controls={can('create', 'delivery') ? (
                    <button onClick={(event) => {
                        event.preventDefault();
                        onChangePage(DELIVERY_PAGES.CREATE, null);
                    }} className={"btn font-weight-bold btn-eh-lilac px-4 m-0"}>
                        <i className={"far fa-plus-circle mr-2"} />
                        <span>{"Create Delivery"}</span>
                    </button>
                ) : null}
            >
                <div className={"row m-0 p-0"}>
                    <div className={"col-12 m-0 p-0"}>
                        <div className="data-table">
                            <AjaxDynamicDataTable
                                apiUrl={route('web-api.job.order.delivery.data-table', {job: jobId, order: orderId}).toString()}
                                loadingComponent={<LoadingIndicator />}
                                noDataComponent={<EmptyTable itemName="deliveries" />}
                                fieldsToExclude={[
                                    'created_at',
                                    'deleted_at',
                                    'can',
                                    'order_id',
                                ]}
                                alwaysShowPagination
                                fieldOrder={[
                                    "id",
                                    "delivery_at",
                                    "products_count",
                                    "user_name",
                                    "status",
                                ]}
                                fieldMap={{
                                    id:             "Delivery Ref",
                                    delivery_at:    "Delivery Date",
                                    products_count: "Products",
                                    user_name:      "Driver Assigned",
                                }}
                                ref={dataTableRef}
                                defaultOrderByField={'id'}
                                defaultOrderByDirection={'asc'}
                                buttons={(row) => renderRowButton(row)}
                                dataItemManipulator={(field, value, row) => {
                                    switch (field) {
                                        case 'status':
                                            return (
                                                <span className={"text-eh-light-blue font-weight-bold"}>{value}</span>
                                            );
                                    }

                                    return <span>{value}</span>;
                                }}
                            />
                        </div>
                    </div>
                </div>
            </Card>
            <ArchiveDeliveryModal
                show={!!archiveDeliveryModal}
                jobId={jobId}
                orderId={orderId}
                deliveryId={!!archiveDeliveryModal ? archiveDeliveryModal.id : null}
                parentId={parentId}
                onCancel={() => setArchiveDeliveryModal(null)}
                onComplete={(delivery) => {
                    setArchiveDeliveryModal(null)
                    dataTableRef.current.reload();
                    toast.success(<div>Delivery deleted.</div>);
                }}
            />
        </React.Fragment>
    );
}

export default JobOrderDeliveryDataTable;
